import { isNativeOrWebIos } from '@/addons/mobile'

/**
 * A composable function that adjusts the core of an iOS application.
 *
 * This function checks if the current environment is a native or web-based iOS
 * application. If so, it adjusts the height of the app container, header, and
 * content elements to fit the viewport.
 *
 * @returns An object with the `adjustLayout` function, which can be called to
 * perform the core adjustment.
 */
export function useIosLayout() {
  const adjustLayout = () => {
    if (!isNativeOrWebIos()) {
      return
    }

    const app = document.querySelector('[data-app-root]') as HTMLElement
    const header = document.querySelector('[data-app-header]') as HTMLElement
    const content = document.querySelector('[data-app-content]') as HTMLElement

    if (!app || !header || !content) {
      return
    }

    const headerHeight = header.getBoundingClientRect().height || 0
    const shouldSubtractHeader = !content.contains(header)
    app.style.height = `${window.innerHeight}px`
    content.style.height = shouldSubtractHeader
      ? `${window.innerHeight - headerHeight}px`
      : `${window.innerHeight}px`
  }

  return { adjustLayout }
}
